export default __webpack_public_path__ + "static/media/whoWillSeeResults_sm_woman.1bc7d978.png";